import { createRouter, createWebHistory } from 'vue-router';
import PublicHome from '@/components/PublicHome.vue';
import HomeTimeline from '@/assets/pages/HomeTimeline.vue';
import LoginForm from '@/components/LoginForm.vue';
import LoginToken from '@/components/LoginToken.vue';
import PostCreate from '@/components/PostCreate.vue';
import RegisterForm from '@/components/RegisterForm.vue';
import EditProfile from '@/components/EditProfile.vue';
import FollowersFollowing from '@/components/FollowersFollowing.vue';
import UserFollowersFollowing from '@/components/UserFollowersFollowing.vue';
import AllSkiers from '@/components/AllSkiers.vue';
import AllTools from '@/components/AllTools.vue';
import PrivacyPolicy from '@/components/PrivacyPolicy.vue';
import TermsOfService from '@/components/TermsOfService.vue';
import ContactForm from '@/components/ContactForm.vue';
import UserProfile from '@/assets/pages/UserProfile.vue';
import RequestProTip from '@/components/RequestProTip.vue';
import BusinessPartners from '@/components/BusinessPartners.vue';
import AdvertisingPricing from '@/components/AdvertisingPricing.vue';
import PaidTipsExplainer from '@/components/PaidTipsExplainer.vue';
import Notifications from '@/components/Notifications.vue';
import PostDetail from '@/components/PostDetail.vue';
import TipDetail from '@/components/TipDetail.vue';
import WelcomeMessage from '@/components/WelcomeMessage.vue';
import ProTipRequests from '@/components/ProTipRequests.vue';
import SkiSettings from '@/components/SkiSettings.vue';
import CompareMode from '@/components/CompareMode.vue';
import SkiSchools from '@/assets/pages/SkiSchools.vue';
import SkiSchoolCreate from '@/components/SkiSchoolCreate.vue';
import SkiSchoolUpdate from '@/components/SkiSchoolUpdate.vue';
import SkiSchoolDetail from '@/components/SkiSchoolDetail.vue';
import StripeConnectReturn from '@/components/StripeConnectReturn.vue';
import SkiLog from '@/components/SkiLog.vue';
import SkiLogCreate from '@/components/SkiLogCreate.vue';
import SkiLogDetail from '@/components/SkiLogDetail.vue';


const routes = [
  {
    path: '/',
    name: 'PublicHome',
    component: PublicHome
  },
  {
    path: '/timeline',
    name: 'HomeTimeline',
    component: HomeTimeline
  },
  {
    path: '/login',
    name: 'Login',
    component: LoginForm,
  },
  {
    path: '/login-token',
    name: 'LoginToken',
    component: LoginToken,
  },
  {
    path: '/post/create',
    name: 'PostCreate',
    component: PostCreate,
  },
  {
    path: '/create-account',
    name: 'Register',
    component: RegisterForm,
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: () => import('../components/ForgotPassword.vue'),
  },
  {
    path: '/reset-password/:uid/:token',
    name: 'ResetPassword',
    component: () => import('../components/ResetPassword.vue'),
  },
  {
    path: '/edit-profile',
    name: 'EditProfile',
    component: EditProfile,
  },
  {
    path: '/connect/return',
    name: 'StripeConnectReturn',
    component: StripeConnectReturn,
    meta: { requiresAuth: true }
  },
  {
    path: "/:username",
    component: UserProfile,
    name: "UserProfile",
    props: true,
  },
  {
    path: '/my/followers-following',
    name: 'MyFollowersFollowing',
    component: FollowersFollowing,
    meta: { requiresAuth: true }
  },
  {
    path: '/:username/followers-following',
    name: 'UserFollowersFollowing',
    component: UserFollowersFollowing,
    props: true
  },
  {
    path: '/all-skiers',
    name: 'AllSkiers',
    component: AllSkiers,
  },
  {
    path: '/all-tools',
    name: 'AllTools',
    component: AllTools,
    meta: { requiresAuth: true }
  },
  {
    path: '/ski-schools',
    name: 'SkiSchools',
    component: SkiSchools,
  },
  {
    path: '/privacy-policy',
    name: 'PrivacyPolicy',
    component: PrivacyPolicy,
  },
  {
    path: '/terms',
    name: 'TermsOfService',
    component: TermsOfService,
  },
  {
   path:  '/contact',
   name: 'ContactForm',
   component: ContactForm,
  },
  {
    path: '/request-pro-tip',
    name: 'RequestProTip',
    component: RequestProTip,
  },
  {
    path: '/business',
    name: 'Business',
    component: BusinessPartners,
  },
  {
    path: '/advertising',
    name: 'Advertising',
    component: AdvertisingPricing,
  },
  {
    path: '/paid-tips',
    name: 'PaidTips',
    component: PaidTipsExplainer,
  },
  {
    path: '/notifications',
    name: 'Notifications',
    component: Notifications,
    meta: { requiresAuth: true }
  },
  {
    path: '/confirm-email/:uid/:token',
    name: 'EmailConfirmation',
    component: () => import('../components/EmailConfirmation.vue')
  },
  {
    path: '/post/:id',
    name: 'PostDetail',
    component: PostDetail,
    props: true
  },
  {
    path: '/tip/:id',
    name: 'TipDetail',
    component: TipDetail,
    props: true
  },
  {
    path: '/welcome',
    name: 'Welcome',
    component: WelcomeMessage,
    meta: { requiresAuth: true }
  },
  {
    path: '/pro-tip-requests',
    name: 'ProTipRequests',
    component: ProTipRequests,
    meta: { requiresAuth: true }
  },
  {
    path: '/ski-settings',
    name: 'SkiSettings',
    component: SkiSettings,
    meta: { requiresAuth: true }
  },
  {
    path: '/compare',
    name: 'CompareMode',
    component: CompareMode,
    meta: { requiresAuth: true }
  },
  {
    path: '/ski-school/create',
    name: 'SkiSchoolCreate',
    component: SkiSchoolCreate,
    meta: { requiresAuth: true }
  },
  {
    path: '/ski-school/:slug/edit',
    name: 'SkiSchoolUpdate',
    component: SkiSchoolUpdate,
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/ski-school/:slug',
    name: 'SkiSchoolDetail',
    component: SkiSchoolDetail,
    props: true
  },
  {
    path: '/ski-logs',
    name: 'SkiLog',
    component: SkiLog,
    meta: { requiresAuth: true }
  },
  {
    path: '/ski-logs/create',
    name: 'SkiLogCreate',
    component: SkiLogCreate,
    meta: { requiresAuth: true }
  },
  {
    path: '/ski-logs/:id',
    name: 'SkiLogDetail',
    component: SkiLogDetail,
    props: true,
    meta: { requiresAuth: true }
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

// Add navigation guard to check auth status
router.beforeEach((to, from, next) => {
  const isAuthenticated = !!localStorage.getItem('access_token');
  
  // If user is at root path and is authenticated, redirect to timeline
  if (to.path === '/' && isAuthenticated) {
    next({ name: 'HomeTimeline' });
  } 
  // If route requires auth and user is not authenticated, redirect to public home
  else if (to.meta.requiresAuth && !isAuthenticated) {
    next({ name: 'PublicHome' });
  }
  // Otherwise proceed as normal
  else {
    next();
  }
});

export default router;
